import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../../src/component/admin/AdminLayout";

import {
  getRetreatTypes,
  deleteRetreatType,
} from "../../services/retreatTypeService";
export default function RetreatTypes() {
  const [retreatTypes, setRetreatTypes] =
    useState([]);

  useEffect(() => {
  loadRetreatTypes();
}, []);

const loadRetreatTypes = async () => {
  try {
    const res = await getRetreatTypes();
    setRetreatTypes(res.data);
  } catch (err) {
    console.error(err);
  }
};

const handleDelete = async (id) => {
  const confirmDelete = window.confirm(
    "Delete this retreat type?"
  );

  if (!confirmDelete) return;

  try {
    await deleteRetreatType(id);

    await loadRetreatTypes();

    alert("Deleted Successfully");
  } catch (err) {
    console.error(err);
    alert("Delete failed");
  }
};

  return (
    <AdminLayout>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-4xl font-bold">
          Retreat Types
        </h1>

        <Link
          to="/admin/retreat-types/new"
          className="bg-secondary text-white px-5 py-3 rounded-xl"
        >
          + Add Retreat Type
        </Link>
      </div>

      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b bg-gray-50">
              <th className="p-4 text-left">
                Type Name
              </th>
<th className="p-4 text-left">
  Route
</th>
              <th className="p-4 text-left">
                Hero Title
              </th>

              <th className="p-4 text-left">
                Duration
              </th>

              <th className="p-4 text-left">
                Level
              </th>

              <th className="p-4 text-left">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {retreatTypes.length === 0 ? (
              <tr>
                <td
                  colSpan="5"
                  className="p-8 text-center text-gray-500"
                >
                  No Retreat Types Found
                </td>
              </tr>
            ) : (
              retreatTypes.map((type) => (
                <tr
                  key={type.id}
                  className="border-b"
                >
                  <td className="p-4 font-medium">
                    {type.typeName}
                  </td>
<td className="p-4">
  /{type.route}
</td>
                  <td className="p-4">
                    {type.heroTitle}
                  </td>

                  <td className="p-4">
                    {type.duration}
                  </td>

                  <td className="p-4">
                    {type.level}
                  </td>

<td className="p-4 space-x-3">
  <Link
    to={`/${type.route}`}
    target="_blank"
    className="text-blue-600 hover:underline"
  >
    View
  </Link>

  <Link
  to={`/admin/retreat-types/edit/${type.id}`}
  className="text-green-600 hover:underline"
>
  Edit
</Link>
  <button
    onClick={() => handleDelete(type.id)}
    className="text-red-600"
  >
    Delete
  </button>
</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}